/**
 * Binds a SvelteKit load function with its correct 'error' and 'redirect' functions.
 * @param loader - The load function to bind.
 * @param error - The error function to bind.
 * @param redirect - The redirect function to bind.
 * @returns The bound load function.
 */
export const bindSveltKitLoad = (loader: any, error: Function, redirect: Function): any => {
  return (async (event: any) => {
    try {
      return await loader(event);
    } catch (e: any) {
      if (Number.isInteger(e.status)) {
        if (e.status >= 300) {
          redirect(e.status, e.location);
        } else {
          error(e.status, e.body.message);
        }
      }
      throw e;
    }
  });
}
